import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";

export const lsStylesFilterValStr = "styles_table_filter_obj";
export const lsFabricTrimsFilterValStr = "fab_trims_table_filter_obj";
export const lsBuyingFilterValStr = "buying_table_filter_obj";

export const hasRemarkFilter = {
	name: "Has Remark",
	key: "has_remark",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.BOOLEAN.key,
	constraints: { DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list: [
			{ name: "Yes", key: "YES" },
			{ name: "No", key: "NO" },
		],
	},
};

export const stylesDashboardExportOptions = [
	{
		key: "STANDARD",
		name: "Standard",
		apiUrl: "/api/designer/download_styles",
		fileName: "styles",
		usePythonApi: false,
	},
	{
		key: "GINESYS_FORMAT",
		name: "Ginesys Format",
		apiUrl: "/api/download_styles_ginesys_format",
		fileName: "styles_ginesys_format",
		usePythonApi: true,
	},
	{
		key: "FULL_DUMP",
		name: "Full Dump",
		apiUrl: "/api/download_styles_dump",
		fileName: "all_styles_dump",
		usePythonApi: true,
	},
	{
		key: "WASHCARE_FORMAT",
		name: "Washcare Format",
		apiUrl: "/api/download_wash_care_format",
		fileName: "styles_washcare_format",
		usePythonApi: true,
	},
];
